import { useState, useEffect } from 'react'

export default function useLocalStorageState(initialState, key) {
  const [state, setState] = useState(() => {
    if (window.localStorage && window.localStorage.getItem(key)) {
      return {
        ...initialState,
        ...JSON.parse(window.localStorage.getItem(key))
      }
    }

    return initialState
  })

  const onStateChange = (nextState) => {
    setState(nextState)

    if (window.localStorage && window.localStorage.getItem(key)) {
      window.localStorage.setItem(JSON.stringify(nextState))
    }
  }

  return [state, onStateChange]
}
